(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-contents"] && !Shopify.designMode) return;
  try {
    /**
   * Carrito sin recargas.
   *
   * Toda la lógica de abajo es opcional: el formulario ya funciona por sí solo
   * contra las rutas nativas de Shopify, y esto solo intercepta esas mismas
   * acciones para aplicarlas con fetch y volver a pintar la sección.
   *
   * El trabajo real no lo hace el elemento sino el almacén de abajo, que es uno
   * solo para toda la página. La razón es el fallo que arrastraba el panel:
   * cualquiera puede tocar el carrito —el botón de la ficha de producto, una
   * tarjeta del cross-sell, un cambio de cantidad— y si cada uno pinta por su
   * cuenta, el panel acaba enseñando un carrito que ya no existe.
   *
   * Dos decisiones sostienen que eso no vuelva a pasar:
   *
   * 1. El HTML ya renderizado se pide dentro de la misma petición que cambia el
   *    carrito. La Cart AJAX API acepta `sections` y devuelve, junto al carrito
   *    nuevo, el marcado de las secciones que se le pidan. Así no hay una
   *    segunda petición que pueda llegar tarde, adelantarse o servirse de la
   *    caché del navegador: lo que se pinta es exactamente el carrito que acaba
   *    de quedar guardado.
   *
   * 2. Las operaciones se encolan. Dos "agregar" seguidos no compiten: el
   *    segundo espera a que el primero termine de pintar. Sin la cola, la
   *    respuesta más lenta ganaba y borraba a la más nueva.
   */
  const UmbraCartStore = {
    /** Todos los carritos montados: el panel lateral y/o la página /cart. */
    instances: new Set(),

    /** Cola de operaciones. Cada una espera a la anterior. */
    chain: Promise.resolve(),

    /**
     * Marca que el marcado en pantalla puede haber envejecido y hay que pedirlo
     * de nuevo antes de enseñarlo. Se enciende al volver de la caché de
     * navegación, donde la página se restaura tal como se dejó y el carrito
     * pudo cambiar mientras tanto (otra pestaña, el checkout, el botón atrás).
     */
    stale: false,

    root() {
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root;
      }
      return '/';
    },

    /** Los identificadores de sección que hay que volver a renderizar. */
    sections() {
      const ids = [];
      this.instances.forEach((element) => {
        const id = element.sectionId;
        if (id && ids.indexOf(id) === -1) ids.push(id);
      });
      return ids;
    },

    /** Encola una operación detrás de las que ya estén corriendo. */
    serial(task) {
      const run = this.chain.then(task, task);
      this.chain = run.then(
        () => {},
        () => {}
      );
      return run;
    },

    setBusy(state) {
      this.instances.forEach((element) => element.setBusy(state));
    },

    /**
     * Sustituye el contenido de cada carrito montado por el que devolvió el
     * servidor. Devuelve false si faltó el marcado de alguno, para que quien
     * llame sepa que todavía hay que ir a buscarlo.
     */
    paint(sections) {
      if (!sections || typeof sections !== 'object') return false;

      let complete = true;
      this.instances.forEach((element) => {
        const markup = sections[element.sectionId];
        if (typeof markup !== 'string' || !element.absorb(markup)) complete = false;
      });

      if (complete) this.announce();
      return complete;
    },

    /**
     * Vuelve a pedir las secciones por su cuenta. Es el camino de respaldo:
     * cuando la respuesta de la mutación no trajo el marcado, y cuando hay que
     * refrescar sin cambiar nada.
     */
    async pull() {
      const ids = this.sections();
      if (ids.length === 0) return false;

      const url = new URL(window.location.href);
      url.searchParams.set('sections', ids.join(','));

      const response = await fetch(url.toString(), {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!response.ok) return false;

      const painted = this.paint(await response.json());
      return painted;
    },

    /**
     * Cambia el carrito y pinta el resultado. El `sections` que viaja en el
     * cuerpo es lo que hace que la respuesta traiga ya el HTML nuevo.
     */
    async request(path, body) {
      const ids = this.sections();
      const payload = Object.assign({}, body);

      if (ids.length > 0) {
        payload.sections = ids.join(',');
        payload.sections_url = window.location.pathname + window.location.search;
      }

      this.setBusy(true);

      try {
        let response;

        try {
          response = await fetch(this.root() + path, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload),
          });
        } catch (error) {
          // La petición no llegó a completarse y no hay forma de saber si el
          // carrito cambió o no. Se intenta releer el estado real antes de
          // avisar del fallo: es preferible a dejar en pantalla una cantidad
          // que quizá nadie guardó.
          await this.pull().catch(() => {});
          throw error;
        }

        let data = null;
        try {
          data = await response.json();
        } catch (error) {
          data = null;
        }

        // Shopify rechazó el cambio: no quedan existencias, la línea ya no
        // existe, el código no aplica. Lo que hay en pantalla ya no describe
        // nada, así que se vuelve a pintar el carrito real antes de avisar.
        if (!response.ok) {
          await this.pull().catch(() => {});
          const message = (data && (data.description || data.message)) || 'cart_error';
          const failure = new Error(message);
          failure.response = data;
          throw failure;
        }

        // El cambio ya está guardado. Si el HTML no vino en la respuesta se
        // pide aparte, y si tampoco así se consigue, el marcado queda marcado
        // como viejo para que se refresque antes de volver a enseñarse. El
        // cambio no se da por fallido: sí ocurrió.
        if (!this.paint(data && data.sections)) {
          const painted = await this.pull().catch(() => false);
          if (!painted) this.stale = true;
        }

        return data;
      } finally {
        this.setBusy(false);
      }
    },

    add(items) {
      return this.serial(() => this.request('cart/add.js', { items: items }));
    },

    change(line, quantity) {
      return this.serial(() => this.request('cart/change.js', { line: line, quantity: quantity }));
    },

    update(body) {
      return this.serial(() => this.request('cart/update.js', body));
    },

    refresh() {
      return this.serial(() => this.pull());
    },

    /**
     * Garantiza que lo que está a punto de verse corresponde al carrito real.
     * En el camino normal no cuesta nada: el marcado ya se pintó con la misma
     * respuesta que guardó el cambio, así que no hay nada que pedir.
     */
    async ensureFresh() {
      if (!this.stale) return;
      this.stale = false;

      try {
        await this.refresh();
      } catch (error) {
        this.stale = true;
      }
    },

    /**
     * Publica el conteo recién pintado. El número no se calcula aquí: se lee del
     * marcado que acaba de devolver el servidor, que es la única cifra que no
     * puede contradecir a lo que se está viendo.
     */
    announce() {
      const first = this.instances.values().next().value;
      if (!first) return;

      const count = Number(first.dataset.itemCount);
      if (Number.isNaN(count)) return;

      document.querySelectorAll('[data-cart-badge]').forEach((badge) => {
        badge.textContent = count;
        badge.hidden = count === 0;
      });

      document.querySelectorAll('[data-cart-badge-label]').forEach((label) => {
        label.textContent = label.textContent.replace(/\d+/, count);
      });

      document.dispatchEvent(new CustomEvent('umbra:cart:changed', { detail: { count: count } }));
    },
  };

  window.UmbraCartStore = UmbraCartStore;

  // La caché de navegación devuelve la página congelada tal como se dejó. El
  // carrito pudo cambiar en ese intervalo, así que el marcado se marca viejo y
  // se vuelve a pedir antes de enseñarlo.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) UmbraCartStore.stale = true;
  });

  /**
   * El elemento se ocupa solo de la parte visible: escuchar los gestos del
   * carrito y adaptar el marcado servido para el caso sin JavaScript.
   *
   * Por eso el primer gesto de connectedCallback es revelar los botones − y + y
   * retirar el botón "Actualizar": esos dos controles solo tienen sentido
   * cuando hay JavaScript, así que el HTML se sirve al revés.
   */
  class UmbraCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.noteTimer = null;

      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onNoteInput = this.onNoteInput.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('input', this.onNoteInput);
      this.addEventListener('keydown', this.onKeydown);

      UmbraCartStore.instances.add(this);
      this.enhance();
      this.dropOrphanProtection();
    }

    disconnectedCallback() {
      UmbraCartStore.instances.delete(this);
      window.clearTimeout(this.noteTimer);
    }

    /**
     * Adopta el marcado recién renderizado por el servidor.
     *
     * Se sustituye el interior y no el elemento entero a propósito: este nodo es
     * el que tiene los escuchadores, y dentro del panel lateral vive en un
     * <dialog> abierto que no puede reemplazarse sin cerrarlo en la cara de
     * quien está comprando.
     */
    absorb(markup) {
      const fresh = new DOMParser().parseFromString(markup, 'text/html').querySelector('umbra-cart');

      if (!fresh) return false;

      this.innerHTML = fresh.innerHTML;
      this.dataset.itemCount = fresh.dataset.itemCount || '0';

      // El atributo viaja en el marcado servido, así que se copia junto con él.
      if (fresh.hasAttribute('data-protection-orphan')) {
        this.setAttribute('data-protection-orphan', fresh.getAttribute('data-protection-orphan'));
      } else {
        this.removeAttribute('data-protection-orphan');
      }

      this.enhance();
      this.dropOrphanProtection();
      return true;
    }

    /**
     * En el carrito no queda más que la protección de envío. Como no se lista
     * entre las piezas, dejarla sería un carrito que se ve vacío y cobra algo:
     * se retira y el panel se vuelve a pintar en su estado vacío de verdad.
     *
     * Lo decide el servidor —el atributo solo aparece cuando de verdad no queda
     * otra cosa— y aquí únicamente se ejecuta.
     */
    dropOrphanProtection() {
      const line = Number(this.getAttribute('data-protection-orphan'));
      if (!line) return;

      this.removeAttribute('data-protection-orphan');
      UmbraCartStore.change(line, 0).catch(() => {});
    }

    /** Ajusta el marcado servido para el caso sin JavaScript. */
    enhance() {
      this.querySelectorAll('[data-cart-step]').forEach((button) => {
        button.hidden = false;
      });

      const update = this.querySelector('[data-cart-update]');
      if (update) update.hidden = true;

      this.syncSteps();
    }

    /** El paso de restar se apaga en 1: para llegar a cero está la X. */
    syncSteps() {
      this.querySelectorAll('[data-cart-item]').forEach((item) => {
        const field = item.querySelector('[data-cart-count]');
        const minus = item.querySelector('[data-cart-step="-1"]');
        if (field && minus) minus.disabled = Number(field.value) <= 1;
      });
    }

    onKeydown(event) {
      if (event.key !== 'Escape') return;
      const open = this.querySelector('[data-cart-info].is-open');
      if (!open) return;

      open.classList.remove('is-open');
      const trigger = open.querySelector('[data-cart-info-trigger]');
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    }

    onClick(event) {
      const trigger = event.target.closest('[data-cart-info-trigger]');
      if (trigger) {
        // En táctil no hay hover: el toque es la única forma de abrir la nota.
        const wrapper = trigger.closest('[data-cart-info]');
        const open = wrapper.classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', String(open));
        return;
      }

      const step = event.target.closest('[data-cart-step]');
      if (step) {
        event.preventDefault();
        this.step(step);
        return;
      }

      const remove = event.target.closest('[data-cart-remove]');
      if (remove) {
        event.preventDefault();
        this.change(this.lineOf(remove), 0);
        return;
      }

      // El interruptor de la protección de envío. No guarda estado: enciende
      // añadiendo la pieza y apaga quitándola, y en los dos casos el panel se
      // vuelve a pintar con el carrito que devolvió Shopify, que es quien
      // decide cómo queda el interruptor.
      const protection = event.target.closest('[data-cart-protection-toggle]');
      if (protection) {
        event.preventDefault();

        if (protection.dataset.line) {
          this.change(Number(protection.dataset.line), 0);
        } else {
          UmbraCartStore.add([
            { id: Number(protection.dataset.variantId), quantity: 1 },
          ]).catch(() => {});
        }
        return;
      }

      const add = event.target.closest('[data-cart-add]');
      if (add) {
        event.preventDefault();
        UmbraCartStore.add([{ id: Number(add.value), quantity: 1 }]).catch(() => {});
      }
    }

    /** Un cambio escrito a mano en el campo de cantidad. */
    onChange(event) {
      const field = event.target.closest('[data-cart-count]');
      if (!field) return;

      const quantity = Math.max(0, Number(field.value) || 0);
      this.change(this.lineOf(field), quantity);
    }

    onNoteInput(event) {
      const field = event.target.closest('[data-cart-note-field]');
      if (!field) return;

      // La nota se guarda sola, pero no en cada tecla.
      window.clearTimeout(this.noteTimer);
      this.noteTimer = window.setTimeout(() => {
        UmbraCartStore.update({ note: field.value }).catch(() => {});
      }, 600);
    }

    step(button) {
      const item = button.closest('[data-cart-item]');
      const field = item.querySelector('[data-cart-count]');
      const quantity = Math.max(0, Number(field.value) + Number(button.dataset.cartStep));

      field.value = quantity;
      this.syncSteps();
      this.change(this.lineOf(button), quantity);
    }

    lineOf(element) {
      const item = element.closest('[data-cart-item]');
      return item ? Number(item.dataset.line) : 0;
    }

    change(line, quantity) {
      if (!line) return Promise.resolve();
      return UmbraCartStore.change(line, quantity).catch(() => {});
    }

    setBusy(state) {
      this.setAttribute('aria-busy', String(state));
    }
  }

  if (!customElements.get('umbra-cart')) {
    customElements.define('umbra-cart', UmbraCart);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["drag-behavior"] && !Shopify.designMode) return;
  try {
    class UmbraSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slider-track]');
      if (!this.track) return;

      this.pointerId = null;
      this.startX = 0;
      this.startScroll = 0;

      this.onDown = this.onDown.bind(this);
      this.onMove = this.onMove.bind(this);
      this.onUp = this.onUp.bind(this);

      this.track.addEventListener('pointerdown', this.onDown);
      this.track.addEventListener('pointermove', this.onMove);
      this.track.addEventListener('pointerup', this.onUp);
      this.track.addEventListener('pointercancel', this.onUp);

      this.track.addEventListener('dragstart', (event) => event.preventDefault());

      this.setupBar();
    }

    disconnectedCallback() {
      if (!this.track) return;
      this.track.removeEventListener('pointerdown', this.onDown);
      this.track.removeEventListener('pointermove', this.onMove);
      this.track.removeEventListener('pointerup', this.onUp);
      this.track.removeEventListener('pointercancel', this.onUp);

      window.removeEventListener('load', this.onProgress);
      window.removeEventListener('resize', this.onProgress);
    }

    /** Barra de avance: solo existe si el marcado la pidió. */
    setupBar() {
      this.bar = this.querySelector('[data-slider-bar]');
      this.thumb = this.querySelector('[data-slider-thumb]');
      if (!this.bar || !this.thumb) return;

      this.onProgress = this.onProgress.bind(this);
      this.onBarDown = this.onBarDown.bind(this);
      this.onBarMove = this.onBarMove.bind(this);
      this.onBarUp = this.onBarUp.bind(this);

      this.track.addEventListener('scroll', this.onProgress, { passive: true });

      // Al conectar las fotos aún no han cargado y el recorrido mide cero: se
      // vuelve a medir al terminar la carga y al cambiar el ancho de ventana.
      window.addEventListener('load', this.onProgress);
      window.addEventListener('resize', this.onProgress);

      this.bar.addEventListener('pointerdown', this.onBarDown);
      this.bar.addEventListener('pointermove', this.onBarMove);
      this.bar.addEventListener('pointerup', this.onBarUp);
      this.bar.addEventListener('pointercancel', this.onBarUp);

      this.paintProgress();
    }

    onProgress() {
      if (this.progressFrame) return;

      this.progressFrame = window.requestAnimationFrame(() => {
        this.progressFrame = null;
        this.paintProgress();
      });
    }

    paintProgress() {
      if (!this.thumb) return;

      const visible = this.track.clientWidth;
      const total = this.track.scrollWidth;
      const travel = total - visible;

      // Sin recorrido la barra se llena entera: decir "estás al principio de
      // nada" con un bloque diminuto sería mentir sobre cuánto queda.
      const size = total > 0 ? Math.min(1, visible / total) : 1;
      const at = travel > 0 ? this.track.scrollLeft / travel : 0;

      this.thumb.style.setProperty('--thumb-size', (size * 100).toFixed(2) + '%');
      this.thumb.style.setProperty('--thumb-at', Math.min(1, Math.max(0, at)).toFixed(4));
    }

    /** Lleva el carril al punto de la barra que se tocó. */
    seek(event) {
      const box = this.bar.getBoundingClientRect();
      if (!box.width) return;

      const at = Math.min(1, Math.max(0, (event.clientX - box.left) / box.width));
      this.track.scrollLeft = at * (this.track.scrollWidth - this.track.clientWidth);
    }

    onBarDown(event) {
      this.barPointer = event.pointerId;
      this.bar.setPointerCapture(event.pointerId);
      this.track.classList.add('is-dragging');
      this.seek(event);
    }

    onBarMove(event) {
      if (this.barPointer !== event.pointerId) return;
      this.seek(event);
      event.preventDefault();
    }

    onBarUp(event) {
      if (this.barPointer !== event.pointerId) return;

      if (this.bar.hasPointerCapture(event.pointerId)) {
        this.bar.releasePointerCapture(event.pointerId);
      }

      this.barPointer = null;
      this.track.classList.remove('is-dragging');
    }

    onDown(event) {
      // El dedo y el lápiz se quedan con el scroll nativo, que se siente mejor
      // que cualquier arrastre calculado a mano.
      if (event.pointerType !== 'mouse' || event.button !== 0) return;

      this.pointerId = event.pointerId;
      this.startX = event.clientX;
      this.startScroll = this.track.scrollLeft;
      this.track.setPointerCapture(event.pointerId);
      this.track.classList.add('is-dragging');
    }

    onMove(event) {
      if (this.pointerId !== event.pointerId) return;

      this.track.scrollLeft = this.startScroll - (event.clientX - this.startX);
      event.preventDefault();
    }

    onUp(event) {
      if (this.pointerId !== event.pointerId) return;

      if (this.track.hasPointerCapture(event.pointerId)) {
        this.track.releasePointerCapture(event.pointerId);
      }

      this.pointerId = null;
      this.track.classList.remove('is-dragging');
    }
  }

  if (!customElements.get('umbra-slider')) {
    customElements.define('umbra-slider', UmbraSlider);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["judgeme-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.UmbraJudgeMe) return;

    // Judge.me no sirve más de 30 reseñas por página, así que "todas" son
    // varias peticiones. El tope de páginas existe para que una pieza con
    // miles de reseñas no dispare cien peticiones al abrir el panel.
    const PER_PAGE = 30;
    const MAX_PAGES = 12;

    // Las promesas se guardan, no los resultados: si el carrusel y el panel
    // arrancan a la vez, el segundo se engancha a la petición en vuelo en lugar
    // de disparar una idéntica.
    const inFlight = new Map();

    function escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    // Judge.me no manda un booleano: manda "buyer", "verified-review-badge" o
    // vacío según cómo se recogió la reseña. Todo lo que no sea una negación
    // explícita cuenta como compra verificada.
    function verifiedFlag(value) {
      if (value === true) return true;
      if (typeof value !== 'string') return false;
      const flag = value.trim().toLowerCase();
      return flag !== '' && flag !== 'no' && flag !== 'none' && flag !== 'false' && flag !== 'unverified';
    }

    function pictureOf(review) {
      const list = review.pictures || review.images || [];
      if (!list.length) return null;

      const first = list[0];
      if (typeof first === 'string') return first;

      const urls = first.urls || first;
      return urls.compact || urls.small || urls.original || urls.huge || null;
    }

    // La miniatura que trae el marcado de Judge.me viene pedida a 160px, la
    // mitad de lo que mide el hueco de una reseña en el tema. Se le pide al
    // mismo archivo un tamaño mayor en vez de estirar el pequeño.
    function sizedPicture(source) {
      if (!source) return null;
      if (!/[?&]width=\d+/.test(source)) return source;
      return source.replace(/([?&]width=)\d+/, '$1480');
    }

    function normalize(review) {
      const reviewer = review.reviewer || {};

      return {
        id: String(review.id != null ? review.id : Math.random().toString(36).slice(2)),
        name: String(review.name || reviewer.name || '').trim(),
        rating: Math.max(0, Math.min(5, Math.round(Number(review.rating) || 0))),
        title: String(review.title || '').trim(),
        body: String(review.body || review.text || '').trim(),
        verified: verifiedFlag(review.verified),
        picture: pictureOf(review),
      };
    }

    /**
     * Traduce el marcado del widget de Judge.me a los mismos objetos que
     * devuelve `normalize`, para que a los componentes les dé igual de qué
     * origen vinieron las reseñas.
     *
     * El documento que crea DOMParser es inerte: las fotos de las reseñas no se
     * descargan por leerlas aquí, solo cuando el componente las pinta.
     */
    function parseWidgetHtml(html) {
      const doc = new DOMParser().parseFromString(String(html || ''), 'text/html');
      const nodes = doc.querySelectorAll('.jdgm-rev[data-review-id]');

      return Array.prototype.map.call(nodes, function (node) {
        function read(selector) {
          const found = node.querySelector(selector);
          return found ? found.textContent.trim() : '';
        }

        const score = node.querySelector('.jdgm-rev__rating');
        const image = node.querySelector('.jdgm-rev__pic-img');
        const link = node.querySelector('.jdgm-rev__pic-link');
        const source =
          (image && image.getAttribute('data-src')) ||
          (image && image.getAttribute('src')) ||
          (link && link.getAttribute('href')) ||
          null;

        return {
          id: node.getAttribute('data-review-id'),
          name: read('.jdgm-rev__author'),
          rating: Math.max(0, Math.min(5, Math.round(Number(score && score.getAttribute('data-score')) || 0))),
          title: read('.jdgm-rev__title'),
          body: read('.jdgm-rev__body'),
          verified: node.getAttribute('data-verified-buyer') === 'true',
          picture: sizedPicture(source),
        };
      });
    }

    function average(reviews) {
      if (!reviews.length) return 0;
      const sum = reviews.reduce((total, review) => total + review.rating, 0);
      return Math.round((sum / reviews.length) * 10) / 10;
    }

    // Los dos orígenes antiguos aceptan un filtro por pieza en la propia
    // consulta. Familia no manda ninguno y sigue trayendo el listado completo.
    function scopeTo(url, config) {
      if (config.externalId) url.searchParams.set('external_id', config.externalId);
      if (config.handle) url.searchParams.set('handle', config.handle);
    }

    /**
     * De dónde salen las reseñas. El orden es el de la intención: lo que el
     * merchant configuró a mano manda sobre lo que el tema hace por su cuenta.
     */
    function sourceOf(config) {
      if (config.endpoint) return 'endpoint';
      if (config.token && config.shopDomain) return 'token';
      if (config.shopDomain) return 'widget';
      return null;
    }

    function urlFor(config, kind, page, perPage) {
      const size = perPage || config.perPage || PER_PAGE;

      if (kind === 'endpoint') {
        const url = new URL(config.endpoint, window.location.origin);
        if (!url.searchParams.has('per_page')) url.searchParams.set('per_page', size);
        url.searchParams.set('page', String(page));
        scopeTo(url, config);
        return url.toString();
      }

      if (kind === 'token') {
        const url = new URL('https://judge.me/api/v1/reviews');
        url.searchParams.set('api_token', config.token);
        url.searchParams.set('shop_domain', config.shopDomain);
        url.searchParams.set('per_page', size);
        url.searchParams.set('page', String(page));
        scopeTo(url, config);
        return url.toString();
      }

      // El origen público. `url` y `shop_domain` llevan el mismo valor: es la
      // pareja que espera el endpoint del widget.
      const url = new URL('https://api.judge.me/reviews/reviews_for_widget');
      url.searchParams.set('url', config.shopDomain);
      url.searchParams.set('shop_domain', config.shopDomain);
      url.searchParams.set('platform', 'shopify');
      url.searchParams.set('page', String(page));
      url.searchParams.set('per_page', String(Math.min(size, PER_PAGE)));
      if (config.productId) url.searchParams.set('product_id', config.productId);
      return url.toString();
    }

    function fetchPage(config, page, perPage) {
      const kind = sourceOf(config);
      if (!kind) return Promise.reject(new Error('judgeme:unconfigured'));

      const url = urlFor(config, kind, page || 1, perPage);
      if (inFlight.has(url)) return inFlight.get(url);

      const request = fetch(url, { headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error('judgeme:http-' + response.status);
          return response.json();
        })
        .then((payload) => {
          // El widget devuelve el marcado ya montado; los otros dos orígenes,
          // el sobre de la API con las reseñas en JSON.
          const parsed =
            typeof payload.html === 'string'
              ? parseWidgetHtml(payload.html)
              : (Array.isArray(payload) ? payload : payload.reviews || []).map(normalize);

          return {
            reviews: parsed.filter((review) => review.body !== ''),
            total: Number(payload.total_count || payload.total || payload.count) || 0,
            average: Number(payload.average_rating) || 0,
          };
        });

      inFlight.set(url, request);

      // Un fallo no se cachea: si la red vuelve, el siguiente consumidor debe
      // poder reintentar en lugar de heredar el error para siempre.
      request.catch(() => inFlight.delete(url));

      return request;
    }

    /**
     * El promedio y el total de la pieza no salen del listado: salen del
     * metafield que Judge.me deja en el producto y que Liquid ya imprimió en la
     * configuración. Es la única cifra fiel —el listado es una página de
     * treinta sobre, quizá, trescientas— y además llega desde el servidor, sin
     * esperar a ninguna petición.
     */
    function summarize(config, batch, reviews) {
      const counted = reviews || batch.reviews;

      return {
        total: Number(config.total) || batch.total || counted.length,
        average: Number(config.average) || batch.average || average(counted),
      };
    }

    /**
     * Varias piezas a la vez. Familia no habla de un producto sino de la marca,
     * y el origen público acota por producto: no sabe devolver "las de la
     * tienda". Así que se le piden unas pocas a cada pieza y se intercalan —una
     * de cada, y vuelta a empezar— para que el carrusel no enseñe seis seguidas
     * del mismo modelo.
     */
    function loadMany(config, perProduct) {
      const ids = config.productIds;
      const size = perProduct || Math.max(2, Math.ceil((Number(config.perPage) || 12) / ids.length));

      const batches = ids.map((id) =>
        fetchPage(Object.assign({}, config, { productId: id }), 1, size).catch(() => ({
          reviews: [],
          total: 0,
        }))
      );

      return Promise.all(batches).then((results) => {
        const reviews = [];
        const depth = results.reduce((max, batch) => Math.max(max, batch.reviews.length), 0);

        for (let row = 0; row < depth; row += 1) {
          results.forEach((batch) => {
            if (batch.reviews[row]) reviews.push(batch.reviews[row]);
          });
        }

        const total = results.reduce((sum, batch) => sum + (batch.total || batch.reviews.length), 0);

        return { reviews: reviews, total: total, average: average(reviews) };
      });
    }

    function hasMany(config) {
      return Array.isArray(config.productIds) && config.productIds.length > 0 && !config.productId;
    }

    function load(config) {
      if (!config || !config.enabled) {
        return Promise.reject(new Error('judgeme:disabled'));
      }

      if (hasMany(config)) return loadMany(config);

      return fetchPage(config, 1).then((batch) => {
        const summary = summarize(config, batch);
        return { reviews: batch.reviews, total: summary.total, average: summary.average };
      });
    }

    /**
     * Todas las reseñas de la pieza, no la primera página. Lo usa el panel
     * completo, donde los filtros por estrellas solo dicen la verdad si están
     * contando sobre el listado entero.
     *
     * La primera página decide cuántas quedan y el resto se piden a la vez: una
     * detrás de otra, treinta a treinta, el panel tardaría en abrirse lo que
     * sumaran todas las esperas.
     */
    function loadAll(config) {
      if (!config || !config.enabled) {
        return Promise.reject(new Error('judgeme:disabled'));
      }

      // Sin una pieza a la que agarrarse, "todas" son las de cada pieza: se
      // pide la primera página completa de cada una en vez de recorrer una sola.
      if (hasMany(config)) return loadMany(config, PER_PAGE);

      return fetchPage(config, 1, PER_PAGE).then((first) => {
        const total = Number(config.total) || first.total || first.reviews.length;
        const pages = Math.min(Math.ceil(total / PER_PAGE), MAX_PAGES);

        if (pages <= 1 || first.reviews.length === 0) {
          const summary = summarize(config, first);
          return { reviews: first.reviews, total: summary.total, average: summary.average };
        }

        const rest = [];
        for (let page = 2; page <= pages; page += 1) {
          // Una página que falle no puede dejar fuera a las que sí llegaron: se
          // cuenta como vacía y el panel enseña el resto.
          rest.push(fetchPage(config, page, PER_PAGE).catch(() => ({ reviews: [] })));
        }

        return Promise.all(rest).then((batches) => {
          const reviews = batches.reduce(
            (all, batch) => all.concat(batch.reviews),
            first.reviews.slice()
          );

          const summary = summarize(config, first, reviews);
          return { reviews: reviews, total: summary.total, average: summary.average };
        });
      });
    }

    // Las estrellas se dibujan aquí y no en cada componente para que el marcado
    // de una reseña traída por la API sea idéntico al de una escrita a mano en
    // el editor.
    function starsHtml(rating, baseClass) {
      let html = '';
      for (let star = 1; star <= 5; star += 1) {
        const on = star <= rating ? ' ' + baseClass + '--on' : '';
        html += '<span class="' + baseClass + on + '">&#9733;</span>';
      }
      return html;
    }

    function parseConfig(element, attribute) {
      const raw = element.getAttribute(attribute || 'data-judgeme');
      if (!raw) return null;

      try {
        return JSON.parse(raw);
      } catch (error) {
        return null;
      }
    }

    window.UmbraJudgeMe = {
      load: load,
      loadAll: loadAll,
      normalize: normalize,
      average: average,
      starsHtml: starsHtml,
      escapeHtml: escapeHtml,
      parseConfig: parseConfig,
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-fullset"] && !Shopify.designMode) return;
  try {
    /**
   * Contador de la mini galería del nivel 2. La foto que se está viendo se
   * deduce de la posición del carril y no se guarda en ninguna variable: el
   * carril es la única fuente de verdad y así el número nunca puede
   * contradecir a lo que se ve, venga el movimiento de un dedo, del ratón o
   * del teclado.
   *
   * El cálculo no ocurre en el evento de scroll: el evento solo apunta que hay
   * trabajo pendiente y requestAnimationFrame lo resuelve una vez por cuadro.
   */
  class UmbraFullsetTile extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-fullset-track]');
      this.counter = this.querySelector('[data-fullset-counter]');
      if (!this.track || !this.counter) return;

      this.total = Number(this.dataset.total) || this.track.children.length;
      this.frame = null;
      this.onScroll = this.onScroll.bind(this);

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.update();
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      if (this.frame) window.cancelAnimationFrame(this.frame);
    }

    onScroll() {
      if (this.frame) return;

      this.frame = window.requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    update() {
      const step = this.track.clientWidth || 1;
      const index = Math.round(this.track.scrollLeft / step);
      const shown = Math.min(this.total, Math.max(1, index + 1));

      this.counter.textContent = shown + '/' + this.total;
    }
  }

  if (!customElements.get('umbra-fullset-tile')) {
    customElements.define('umbra-fullset-tile', UmbraFullsetTile);
  }

  /**
   * Nivel 1 del capítulo Full Set: dibuja el fotograma que le toca a la
   * posición del scroll y abre la tarjeta del elemento que se toque.
   *
   * El dibujado no ocurre en el evento de scroll: el evento solo apunta que hay
   * trabajo pendiente y `requestAnimationFrame` lo hace una vez por cuadro. Sin
   * ese filtro, un trackpad dispara decenas de eventos entre dos cuadros y se
   * pagarían decenas de `drawImage` que nadie llega a ver.
   *
   * Las imágenes se guardan como <img> y no como ImageBitmap a propósito: un
   * ImageBitmap se queda descomprimido en memoria mientras exista la
   * referencia, y 77 fotogramas de 1712x1208 son varios cientos de megas. Con
   * <img> el navegador puede soltar la versión descomprimida bajo presión de
   * memoria y volver a descomprimirla desde los 37 KB del archivo, que es
   * justo la decisión que sabe tomar mejor que nosotros.
   */
  class UmbraFullset extends HTMLElement {
    connectedCallback() {
      this.scrub = this.querySelector('[data-fullset-scrub]');
      this.canvas = this.querySelector('[data-fullset-canvas]');
      this.loader = this.querySelector('[data-fullset-loader]');
      this.meter = this.querySelector('[data-fullset-meter]');
      this.hotspots = Array.from(this.querySelectorAll('[data-fullset-hotspot]'));
      this.dialogs = Array.from(this.querySelectorAll('[data-fullset-dialog]'));

      this.frames = [];
      this.started = false;
      this.ready = false;
      this.drawn = -1;
      this.pending = null;
      this.progress = 0;

      this.sticky = this.querySelector('[data-fullset-sticky]');

      // Los dos tramos, en el orden en que se recorren: la caja se abre y luego
      // se queda abierta. No hay un tercero que la cierre —cerrarla es subir el
      // scroll, y eso ya lo hace el scrubbing al revés— ni fases de zoom: el
      // escenario no se mueve ni cambia de tamaño en ningún punto.
      //
      // Son proporciones y no medidas: lo que dura el capítulo en pantallas lo
      // decide el --pin-height de la escena, y estos pesos reparten ese recorrido.
      // Cambiar uno no obliga a recalcular el otro.
      const abrir = this.readWeight('phaseOpen', 450);
      const pausa = this.readWeight('phaseHold', 200);

      this.bounds = this.repartir([abrir, pausa]);

      this.onScroll = this.onScroll.bind(this);

      // Punto y tarjeta se emparejan por su clave y no por su posición en la
      // lista: la de la caja se llama "box" y las otras tres van numeradas, así
      // que un índice de arreglo no serviría para las cuatro.
      this.porClave = new Map();
      this.hotspots.forEach((boton) => {
        const clave = boton.dataset.fullsetHotspot;
        this.porClave.set(clave, boton);
        boton.addEventListener('click', () => this.abrir(clave));
      });

      this.dialogs.forEach((dialog) => {
        const i = dialog.dataset.fullsetDialog;
        // El punto vuelve a "cerrado" en la misma llamada que cierra el
        // diálogo, sin esperar al evento: el estado que anuncia el botón no
        // debería depender de que llegue un aviso posterior.
        const cerrar = () => {
          dialog.close();
          this.marcar(i, false);
        };

        const boton = dialog.querySelector('[data-fullset-close]');
        if (boton) boton.addEventListener('click', cerrar);

        // El clic en el fondo cierra, igual que en el panel de reseñas: en un
        // <dialog> modal el propio elemento es el área que rodea al contenido.
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) cerrar();
        });

        // Escape no pasa por ninguno de los dos caminos de arriba: lo cierra el
        // navegador y solo avisa con estos eventos. "cancel" cubre Escape y
        // "close" el resto, igual que en el panel de reseñas.
        dialog.addEventListener('cancel', () => this.marcar(i, false));
        dialog.addEventListener('close', () => this.marcar(i, false));
      });

      // Con el movimiento apagado el capítulo se queda en su estado final: la
      // escena deja de estar clavada y no hay recorrido que el scrubbing pueda
      // seguir, así que se dibuja el fotograma de la caja abierta —el de la fase
      // de pausa— con sus cuatro puntos a la vista. Es el único fotograma que deja
      // todo el capítulo al alcance: con la caja cerrada no habría nada que
      // tocar y las tarjetas quedarían inaccesibles.
      //
      // Se carga la secuencia entera para llegar a ese fotograma. Es el precio
      // de que el capítulo siga contando lo mismo sin movimiento; el ahorro
      // estaría en pedir solo el último archivo, y eso obligaría a un camino de
      // carga aparte que solo existiría para este caso.
      this.quieto = !this.hayMovimiento();

      if (this.quieto) {
        this.load();
        this.update();
        return;
      }

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      this.update();
    }

    /** El mando del tema y el del sistema, en ese orden. */
    hayMovimiento() {
      if (document.documentElement.dataset.motion === 'off') return false;
      return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      if (this.pending) cancelAnimationFrame(this.pending);
    }

    /** Lee un número del editor, con respaldo si viene vacío o ilegible. */
    readWeight(name, fallback) {
      const raw = Number(this.dataset[name]);
      if (!Number.isFinite(raw)) return fallback;
      if (raw <= 0) return fallback;
      return raw;
    }

    /**
     * Convierte los pesos de las fases en los límites [inicio, fin] de cada una
     * dentro del recorrido completo, en tanto por uno. Trabajar con pesos y no
     * con posiciones fijas permite cambiar la duración de una fase en el editor
     * sin recalcular las demás a mano.
     */
    repartir(pesos) {
      const total = pesos.reduce((a, b) => a + b, 0);
      let acumulado = 0;
      return pesos.map((peso) => {
        const inicio = acumulado / total;
        acumulado += peso;
        return [inicio, acumulado / total];
      });
    }

    /** Cuánto se ha recorrido de la fase `i`, en tanto por uno. */
    tramo(i) {
      const [inicio, fin] = this.bounds[i];
      if (fin <= inicio) return 1;
      return Math.min(Math.max((this.progress - inicio) / (fin - inicio), 0), 1);
    }

    load() {
      if (this.started) return;
      this.started = true;

      const source = this.querySelector('[data-fullset-frames]');
      if (!source) return;

      let urls = [];
      try {
        urls = JSON.parse(source.textContent);
      } catch (error) {
        return;
      }
      if (!Array.isArray(urls) || urls.length === 0) return;

      this.frames = new Array(urls.length);

      let done = 0;
      let ok = 0;

      const cuenta = () => {
        done += 1;
        if (this.meter) this.meter.style.inlineSize = `${Math.round((done / urls.length) * 100)}%`;
        if (done < urls.length) return;

        // Si no cargó ni un fotograma no se habilita el recorrido: el cargador
        // se queda puesto en vez de dejar un rectángulo vacío que sí responde.
        if (ok === 0) return;

        this.ready = true;
        this.classList.add('is-ready');
        this.update();
      };

      urls.forEach((url, i) => {
        const image = new Image();
        image.decoding = 'async';

        image.addEventListener('load', () => {
          this.frames[i] = image;
          ok += 1;

          // El lienzo se dimensiona con el primer fotograma que llegue, no con
          // el número uno: si justo ese fallara, esperar por él dejaría el
          // capítulo sin dibujar nunca. Detrás del cargador ya se ve la caja
          // cerrada en lugar de un hueco.
          if (!this.context) this.size(image);
          cuenta();
        });

        // Un fotograma que falta no puede colgar el cargador para siempre: se
        // cuenta igual y el hueco se resuelve dibujando el vecino más cercano.
        image.addEventListener('error', cuenta);

        image.src = url;
      });
    }

    /**
     * El lienzo se dimensiona al tamaño real del fotograma, no al de pantalla:
     * así `drawImage` copia píxel a píxel sin reescalar y la nitidez no depende
     * de la densidad del dispositivo. El encogido lo hace el CSS.
     */
    size(image) {
      if (!this.canvas) return;
      if (!image.naturalWidth) return;

      this.canvas.width = image.naturalWidth;
      this.canvas.height = image.naturalHeight;
      this.style.setProperty('--frame-ratio', `${image.naturalWidth} / ${image.naturalHeight}`);

      this.context = this.canvas.getContext('2d');
      this.drawn = -1;

      // Se repinta por la vía normal: `render` es quien sabe qué fotograma toca
      // en este punto del recorrido, y también deja puesta la escala.
      this.render();
    }

    onScroll() {
      if (this.pending) return;
      this.pending = window.requestAnimationFrame(() => {
        this.pending = null;
        this.update();
      });
    }

    update() {
      if (!this.scrub) return;

      // Sin movimiento no hay recorrido: la escena ya no está clavada y el
      // rectángulo del contenedor no significa nada. Se planta en mitad de la
      // fase de pausa, que es la caja abierta con sus puntos. `load` llama
      // aquí al terminar, así que esta guarda es también la que evita que ese
      // aviso reintroduzca el scrubbing.
      if (this.quieto) {
        this.progress = (this.bounds[1][0] + this.bounds[1][1]) / 2;
        this.render();
        return;
      }

      const caja = this.scrub.getBoundingClientRect();

      // La carga no arranca con la página: son casi tres megas que competirían
      // con las fotos del producto y con el bloque de compra, que es lo primero
      // que hay que poder usar. Empieza cuando el capítulo queda a dos pantallas
      // de distancia, medido con el mismo rectángulo que ya se pide para fijar
      // el fotograma — por geometría y no con un observador, igual que los
      // capítulos y los puntos de sección.
      if (caja.top < window.innerHeight * 2) this.load();

      const recorrido = this.recorrido(caja);
      if (recorrido <= 0) return;

      // 0 cuando la escena acaba de fijarse, 1 cuando termina su recorrido.
      this.progress = Math.min(Math.max(-caja.top / recorrido, 0), 1);

      this.render();
    }

    /**
     * El recorrido de la animación, en píxeles de scroll.
     *
     * No es el alto del contenedor: es el tramo en el que esta escena se ve
     * sola. La escena siguiente arranca una pantalla antes de que la caja de
     * esta termine —esa es la cortina del montaje—, así que la última pantalla
     * del pineado es justo la que la entrante va a tapar. Llevar la animación
     * hasta allí la dejaría terminando por debajo de una capa opaca: la caja se
     * cerraría donde ya no se ve.
     *
     * El final se mide contra la caja real de la escena siguiente en vez de
     * restar una pantalla a ojo: en móvil svh y la altura del viewport no
     * siempre coinciden, y este punto tiene que caer exactamente donde la de
     * abajo empieza a asomar. Es la misma lección de Familia.
     */
    recorrido(caja) {
      let siguiente = this.nextElementSibling;
      while (siguiente && !siguiente.classList.contains('pstory__block')) {
        siguiente = siguiente.nextElementSibling;
      }

      if (siguiente) {
        // Las dos cajas se mueven juntas con el scroll, así que su separación es
        // constante y da igual en qué punto del recorrido se mida.
        const hueco = siguiente.getBoundingClientRect().top - caja.top;
        return Math.max(hueco - window.innerHeight, 1);
      }

      // Sin escena detrás no hay cortina que esquivar: el recorrido es el del
      // contenedor menos el alto de la capa clavada, que es cuánto tiempo se
      // queda pegada.
      const alto = this.sticky ? this.sticky.getBoundingClientRect().height : window.innerHeight;
      return Math.max(caja.height - alto, 1);
    }

    /**
     * Reparte el recorrido entre las dos fases. Cada una decide dos cosas: qué
     * fotograma toca y si los puntos están a la vista.
     *
     *   1. apertura — del primer fotograma al último
     *   2. pausa    — último fotograma quieto, con los cuatro puntos
     *
     * Lo que no decide ninguna es dónde está la caja ni cuánto mide: el
     * escenario no se toca desde aquí. Este método solo elige un fotograma y
     * enciende o apaga los puntos.
     *
     * El cierre no tiene fase propia. La correspondencia entre posición y
     * fotograma es la misma se llegue bajando o subiendo, así que al subir el
     * scroll la serie se recorre de vuelta sola y la caja se cierra igual de
     * lejos de donde se abrió.
     */
    render() {
      const ultimo = Math.max(this.frames.length - 1, 0);
      const p = this.progress;

      let indice = 0;
      let abierta = false;

      if (p < this.bounds[0][1]) {
        indice = Math.round(this.tramo(0) * ultimo);
      } else {
        indice = ultimo;
        abierta = true;
      }

      // Mientras falten fotogramas el recorrido no manda sobre cuál se dibuja:
      // se queda clavado en el primero. Es lo que separa "cargando" de "listo"
      // — con la secuencia a medias, el avance saltaría al cuadro cargado más
      // cercano y se leería como una animación rota, no como una en curso.
      if (!this.ready) indice = 0;

      // Los tres puntos de los elementos y el de la caja se encienden a la vez,
      // en la pausa. Son dos clases y no una porque señalan cosas distintas —lo
      // que viene dentro y el envase— y así se puede volver a separarlas sin
      // tocar el CSS de ambas.
      this.classList.toggle('is-open', abierta);
      this.classList.toggle('is-boxed', abierta);

      this.paint(indice);
    }

    paint(indice) {
      if (!this.context) return;
      if (indice === this.drawn) return;

      const image = this.nearest(indice);
      if (!image) return;

      this.context.drawImage(image, 0, 0, this.canvas.width, this.canvas.height);
      this.drawn = indice;
    }

    /**
     * El fotograma pedido, o el más cercano que sí haya cargado. Es lo que
     * mantiene el recorrido continuo si un archivo se quedó por el camino: se
     * repite el vecino en lugar de dejar el lienzo en el cuadro anterior.
     */
    nearest(indice) {
      if (this.frames[indice]) return this.frames[indice];

      for (let salto = 1; salto < this.frames.length; salto += 1) {
        if (this.frames[indice - salto]) return this.frames[indice - salto];
        if (this.frames[indice + salto]) return this.frames[indice + salto];
      }

      return null;
    }

    abrir(clave) {
      const dialog = this.dialogs.find((d) => d.dataset.fullsetDialog === clave);
      if (!dialog) return;
      if (dialog.open) return;

      dialog.showModal();

      // El foco va al contenedor y no al botón de cierre: enfocar un botón por
      // script hace que iOS y Android le apliquen :focus-visible y el anillo se
      // ve como un recuadro al tocar.
      dialog.focus();
      this.marcar(clave, true);
    }

    marcar(clave, abierto) {
      const boton = this.porClave.get(clave);
      if (!boton) return;
      boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    }
  }

  if (!customElements.get('umbra-fullset')) {
    customElements.define('umbra-fullset', UmbraFullset);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    /**
   * Navegación de la galería, bucle infinito, escalado por cercanía al centro y
   * estado del interruptor glow.
   *
   * El desplazamiento se delega en el scroll nativo del carril: las flechas solo
   * llaman a scrollTo, así que el gesto con el dedo y el clic terminan en el
   * mismo sitio y no hay dos fuentes de verdad para el índice.
   */
  class UmbraGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      if (!this.track) return;

      this.originals = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.count = this.originals.length;
      this.slides = this.originals;
      this.loop = this.count > 1;
      this.settleTimer = null;
      this.frame = null;
      this.holding = false;

      const toggle = this.querySelector('[data-glow-toggle]');
      if (toggle) toggle.addEventListener('click', () => this.toggleGlow(toggle));

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onRelease = this.onRelease.bind(this);

      if (this.loop) this.buildLoop();

      const prev = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', () => this.step(-1));
      if (next) next.addEventListener('click', () => this.step(1));

      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      // Mientras el dedo o el ratón siguen apoyados no se salta de copia: mover
      // el scroll por debajo de un gesto en curso lo arruina. El salto queda
      // para cuando el recorrido se detiene solo.
      this.track.addEventListener('pointerdown', () => {
        this.holding = true;
      });
      document.addEventListener('pointerup', this.onRelease);
      document.addEventListener('pointercancel', this.onRelease);

      // Al conectar, las fotos todavía no han cargado y las medidas salen en
      // cero. La posición de partida se vuelve a fijar al terminar la carga y
      // cada vez que cambia el ancho de la ventana.
      window.addEventListener('load', this.onResize);
      window.addEventListener('resize', this.onResize);

      this.paint();
    }

    disconnectedCallback() {
      document.removeEventListener('pointerup', this.onRelease);
      document.removeEventListener('pointercancel', this.onRelease);
      window.removeEventListener('load', this.onResize);
      window.removeEventListener('resize', this.onResize);
      if (this.settleTimer) clearTimeout(this.settleTimer);
    }

    /**
     * Arma el bucle clonando la serie entera antes y después de la original. Se
     * clona la serie completa y no una sola foto a cada lado a propósito: con un
     * único clon, un impulso fuerte con el dedo se pasa de largo y choca contra
     * el final del carril antes de que dé tiempo a saltar.
     */
    buildLoop() {
      const before = document.createDocumentFragment();
      const after = document.createDocumentFragment();

      this.originals.forEach((slide) => {
        before.appendChild(this.copyOf(slide));
        after.appendChild(this.copyOf(slide));
      });

      this.track.insertBefore(before, this.originals[0]);
      this.track.appendChild(after);

      this.slides = Array.from(this.track.children);
      this.center(this.count, 'auto');
    }

    copyOf(slide) {
      const copy = slide.cloneNode(true);

      // Las copias son la misma foto vista otra vez: para un lector de pantalla
      // repetirlas sería anunciar una galería tres veces más larga de lo que es.
      copy.setAttribute('aria-hidden', 'true');
      copy.dataset.galleryClone = 'true';
      copy.querySelectorAll('img').forEach((image) => {
        image.setAttribute('loading', 'lazy');
      });

      return copy;
    }

    /** Cuánto avanza el recorrido de una diapositiva a la siguiente. */
    pitch() {
      if (this.slides.length < 2) return this.track.clientWidth;
      return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
    }

    /** Ancho de una serie completa. */
    setWidth() {
      if (this.slides.length <= this.count) return 0;
      return this.slides[this.count].offsetLeft - this.slides[0].offsetLeft;
    }

    nearest() {
      const middle = this.track.scrollLeft + this.track.clientWidth / 2;
      let best = 0;
      let shortest = Infinity;

      this.slides.forEach((slide, i) => {
        const distance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - middle);
        if (distance < shortest) {
          shortest = distance;
          best = i;
        }
      });

      return best;
    }

    /**
     * Reparte el tamaño de cada diapositiva según su distancia al centro de la
     * pantalla. Es lo que hace que la foto que entra crezca y la que sale se
     * encoja, siguiendo al dedo en vez de saltar al soltar.
     */
    paint() {
      if (!this.loop) return;

      const middle = this.track.scrollLeft + this.track.clientWidth / 2;
      const pitch = this.pitch() || 1;
      const current = this.nearest();

      this.slides.forEach((slide, i) => {
        const distance = Math.abs(slide.offsetLeft + slide.offsetWidth / 2 - middle);
        const t = Math.max(0, 1 - distance / pitch);

        slide.style.setProperty('--t', t.toFixed(3));
        slide.classList.toggle('is-current', i === current);
      });
    }

    center(index, behavior) {
      const slide = this.slides[index];
      if (!slide) return;

      const left = slide.offsetLeft - (this.track.clientWidth - slide.offsetWidth) / 2;
      this.track.scrollTo({ left: left, behavior: behavior });
    }

    step(dir) {
      const motionOff =
        document.documentElement.dataset.motion === 'off' ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.center(this.nearest() + dir, motionOff ? 'auto' : 'smooth');
    }

    onScroll() {
      if (!this.frame) {
        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          this.paint();
        });
      }

      if (this.settleTimer) clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.settle(), 140);
    }

    onRelease() {
      this.holding = false;
    }

    onResize() {
      if (!this.loop) return;
      this.center(this.count + (this.nearest() % this.count), 'auto');
      this.paint();
    }

    settle() {
      this.recenter();
      this.paint();
    }

    /**
     * Devuelve el recorrido a la copia central. El salto mide exactamente una
     * serie, así que la foto bajo el dedo no se mueve ni un píxel: lo único que
     * cambia es cuánto carril queda a cada lado.
     */
    recenter() {
      if (!this.loop || this.holding) return;

      const jump = this.setWidth();
      if (!jump) return;

      const index = this.nearest();
      if (index < this.count) {
        this.track.scrollLeft += jump;
      } else if (index >= this.count * 2) {
        this.track.scrollLeft -= jump;
      }
    }

    toggleGlow(toggle) {
      const encendido = toggle.getAttribute('aria-pressed') === 'true';
      toggle.setAttribute('aria-pressed', encendido ? 'false' : 'true');
      this.classList.toggle('is-glow', !encendido);

      const label = toggle.querySelector('[data-glow-label]');
      if (label) label.textContent = encendido ? label.dataset.off || 'OFF' : label.dataset.on || 'ON';
    }
  }

  if (!customElements.get('umbra-gallery')) {
    customElements.define('umbra-gallery', UmbraGallery);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reviews-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    /**
     * Mini reseñas. Envuelve al carrusel: pide los datos a Judge.me, redibuja
     * las tarjetas cuando llegan y avisa cuando se llega al final del recorrido,
     * que es lo que descubre el botón de todas las opiniones.
     */
    class UmbraReviews extends HTMLElement {
      connectedCallback() {
        this.carousel = this.querySelector('umbra-carousel');
        this.track = this.querySelector('[data-carousel-track]');
        this.cta = this.querySelector('umbra-reviews-cta');

        // La petición se aplaza a una microtarea: el cargador de Judge.me vive
        // en otro archivo del mismo paquete y no hay garantía de que su bloque
        // se haya ejecutado todavía cuando este elemento se actualiza. Al
        // terminar el script completo, ya está publicado.
        Promise.resolve().then(() => this.fetchReviews());
      }

      fetchReviews() {
        if (!window.UmbraJudgeMe || !this.track) return;

        const config = window.UmbraJudgeMe.parseConfig(this);
        if (!config || !config.enabled) return;

        window.UmbraJudgeMe.load(config)
          .then((data) => {
            if (!data.reviews.length) return;
            this.render(data.reviews);
          })
          .catch(() => {
            // Las reseñas del editor ya están impresas: un fallo de red deja el
            // bloque como estaba en lugar de vaciarlo.
          });
      }

      render(reviews) {
        const api = window.UmbraJudgeMe;
        const verifiedLabel = api.escapeHtml(this.dataset.labelVerified || '');

        // Las mismas cuatro que imprime Liquid en el respaldo. El carrusel es
        // una muestra: quien quiera leerlas todas tiene el panel completo en la
        // tarjeta siguiente.
        const cards = reviews
          .slice(0, UmbraReviews.LIMIT)
          .map((review) => {
            // Sin foto no se dibuja el cuadro: un hueco vacío a la izquierda se
            // lee como una imagen que no cargó.
            const photo = review.picture
              ? '<div class="familia__review-photo">' +
                '<img class="familia__review-image" src="' +
                api.escapeHtml(review.picture) +
                '" alt="" loading="lazy" width="256" height="256">' +
                '</div>'
              : '';

            const verified = review.verified
              ? '<p class="familia__verified u-label">' + verifiedLabel + '</p>'
              : '';

            return (
              '<article class="familia__review">' +
              photo +
              '<div class="familia__review-body">' +
              '<div class="familia__review-head">' +
              '<p class="familia__review-name">' +
              api.escapeHtml(review.name) +
              '</p>' +
              '<p class="familia__stars familia__stars--small" aria-hidden="true">' +
              api.starsHtml(review.rating, 'familia__star') +
              '</p>' +
              '</div>' +
              '<div class="familia__review-text"><p>' +
              api.escapeHtml(review.body) +
              '</p></div>' +
              verified +
              '</div>' +
              '</article>'
            );
          })
          .join('');

        this.track.innerHTML = cards;

        // El botón sobrevive al redibujado: es un elemento vivo con su propio
        // comportamiento, así que se vuelve a colgar en lugar de reimprimirlo
        // como cadena de texto y perder sus escuchas.
        if (this.cta) this.track.appendChild(this.cta);

        this.track.scrollLeft = 0;
        if (this.carousel && typeof this.carousel.refresh === 'function') {
          this.carousel.refresh();
        }
      }
    }

    // Cuatro reseñas y la tarjeta final. El mismo tope lo aplica Liquid al
    // respaldo del editor, arriba en este archivo.
    UmbraReviews.LIMIT = 4;

    /**
     * Tarjeta del botón de todas las opiniones. Ya no esconde ni revela nada:
     * al vivir dentro del carrusel, no verse todavía es simplemente no haber
     * llegado. Lo único que le queda es abrir el panel.
     *
     * En el editor, seleccionar el bloque lo trae a pantalla desplazando el
     * carrusel hasta él, que es el equivalente a "mostrarlo".
     */
    class UmbraReviewsCta extends HTMLElement {
      connectedCallback() {
        this.onBlockSelect = this.onBlockSelect.bind(this);

        // El clic se cuelga una sola vez en toda la vida del elemento: al
        // llegar los datos de Judge.me esta tarjeta se saca y se vuelve a
        // colgar de la pista, y sin la guarda acabaría con una escucha por cada
        // reconexión.
        if (!this.wired) {
          this.trigger = this.querySelector('[data-reviews-open]');

          if (this.trigger) {
            this.trigger.addEventListener('click', () => {
              document.dispatchEvent(new CustomEvent('umbra:reviews:open'));
            });
          }

          this.wired = true;
        }

        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onBlockSelect(event) {
        if (!this.contains(event.target)) return;
        this.scrollIntoView({ block: 'nearest', inline: 'start' });
      }
    }

    if (!customElements.get('umbra-reviews-cta')) {
      customElements.define('umbra-reviews-cta', UmbraReviewsCta);
    }

    if (!customElements.get('umbra-reviews')) {
      customElements.define('umbra-reviews', UmbraReviews);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reviews-drawer"] && !Shopify.designMode) return;
  try {
    class UmbraReviewsDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-reviews-dialog]');
      if (!this.dialog) return;

      this.list = this.querySelector('[data-reviews-list]');
      this.empty = this.querySelector('[data-reviews-empty]');
      this.filters = Array.from(this.querySelectorAll('[data-reviews-filter]'));
      this.filter = 'all';
      this.loaded = false;

      this.open = this.open.bind(this);
      this.close = this.close.bind(this);
      this.onFilter = this.onFilter.bind(this);
      this.onDialogClose = this.onDialogClose.bind(this);

      document.addEventListener('umbra:reviews:open', this.open);

      this.querySelectorAll('[data-reviews-close]').forEach((button) => {
        button.addEventListener('click', this.close);
      });

      this.filters.forEach((button) => button.addEventListener('click', this.onFilter));

      // "cancel" cubre el cierre con Escape y "close" el resto. Se escuchan los
      // dos porque no todos los navegadores emiten "close" de forma fiable.
      this.dialog.addEventListener('cancel', this.onDialogClose);
      this.dialog.addEventListener('close', this.onDialogClose);

      // Un clic en el fondo cierra: en una hoja inferior el área visible por
      // detrás es parte del gesto de descarte, no decoración.
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
    }

    disconnectedCallback() {
      document.removeEventListener('umbra:reviews:open', this.open);
    }

    open() {
      if (this.dialog.open) return;

      // Al abrir, el bloqueo de scroll pone el documento en overflow:hidden y
      // el navegador reajusta la posición horizontal por su cuenta. Se guarda
      // para devolverla al cerrar: sin esto la página se queda corrida a un
      // lado y todo se ve cortado.
      this.pageScrollX = window.scrollX;

      this.dialog.showModal();

      // El foco va al contenedor y no al botón de cierre: enfocar un botón por
      // script hace que iOS y Android le apliquen :focus-visible y el anillo se
      // ve como un recuadro al tocar.
      this.dialog.focus();
      this.syncTriggers(true);
      this.fetchReviews();
    }

    close() {
      if (!this.dialog.open) return;
      this.dialog.close();
      this.onDialogClose();
    }

    onDialogClose() {
      this.syncTriggers(false);

      if (typeof this.pageScrollX === 'number') {
        window.scrollTo(this.pageScrollX, window.scrollY);
      }
    }

    syncTriggers(expanded) {
      document.querySelectorAll('[data-reviews-open]').forEach((trigger) => {
        trigger.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    }

    fetchReviews() {
      if (this.loaded || !window.UmbraJudgeMe) return;

      const config = window.UmbraJudgeMe.parseConfig(this);
      if (!config || !config.enabled) return;

      this.loaded = true;

      // `loadAll` y no `load`: este panel es el de "ver todas las opiniones",
      // y sus filtros por estrellas solo dicen la verdad si están contando
      // sobre el listado entero y no sobre la primera página.
      window.UmbraJudgeMe.loadAll(config)
        .then((data) => {
          if (!data.reviews.length) return;
          this.render(data);
        })
        .catch(() => {
          // Las reseñas impresas desde el editor siguen en pantalla: un fallo
          // de red no debe dejar el panel en blanco.
          this.loaded = false;
        });
    }

    render(data) {
      const api = window.UmbraJudgeMe;
      const verifiedLabel = api.escapeHtml(this.dataset.labelVerified || '');

      this.list.innerHTML = data.reviews
        .map((review) => {
          const photo = review.picture
            ? '<img class="reviews-drawer__photo-image" src="' +
              api.escapeHtml(review.picture) +
              '" alt="" loading="lazy" width="320" height="320">'
            : '';

          const verified = review.verified
            ? '<p class="reviews-drawer__verified u-label">' + verifiedLabel + '</p>'
            : '';

          return (
            '<li class="reviews-drawer__item" data-photo="' +
            (review.picture ? 'true' : 'false') +
            '">' +
            '<div class="reviews-drawer__photo">' +
            photo +
            '</div>' +
            '<div class="reviews-drawer__body">' +
            '<div class="reviews-drawer__head">' +
            '<p class="reviews-drawer__name">' +
            api.escapeHtml(review.name) +
            '</p>' +
            '<p class="reviews-drawer__stars reviews-drawer__stars--small" aria-hidden="true">' +
            api.starsHtml(review.rating, 'reviews-drawer__star') +
            '</p>' +
            '</div>' +
            '<div class="reviews-drawer__text"><p>' +
            api.escapeHtml(review.body) +
            '</p></div>' +
            verified +
            '</div>' +
            '</li>'
          );
        })
        .join('');

      this.renderSummary(data);
      this.applyFilter();
    }

    renderSummary(data) {
      const api = window.UmbraJudgeMe;
      const stars = this.querySelector('[data-reviews-summary-stars]');
      const score = this.querySelector('[data-reviews-summary-score]');
      const count = this.querySelector('[data-reviews-summary-count]');

      if (stars) stars.innerHTML = api.starsHtml(Math.round(data.average), 'reviews-drawer__star');
      if (score) score.textContent = String(data.average);

      // El total llega con un hueco marcado desde Liquid porque la frase se
      // traduce entera y el número no va en el mismo sitio en todos los idiomas.
      if (count && this.dataset.labelCount) {
        count.textContent = this.dataset.labelCount.replace('%%', String(data.total));
      }
    }

    onFilter(event) {
      this.filter = event.currentTarget.dataset.reviewsFilter || 'all';

      this.filters.forEach((button) => {
        const active = button === event.currentTarget;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      this.applyFilter();
    }

    applyFilter() {
      let visible = 0;

      this.list.querySelectorAll('.reviews-drawer__item').forEach((item) => {
        const hasPhoto = item.dataset.photo === 'true';
        let keep = true;

        if (this.filter === 'photos') {
          keep = hasPhoto;
        } else if (this.filter === 'no-photos') {
          keep = !hasPhoto;
        }

        item.hidden = !keep;
        if (keep) visible += 1;
      });

      if (this.empty) this.empty.hidden = visible > 0;
      this.list.scrollTop = 0;
    }
  }

  if (!customElements.get('umbra-reviews-drawer')) {
    customElements.define('umbra-reviews-drawer', UmbraReviewsDrawer);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["solo-carousel"] && !Shopify.designMode) return;
  try {
    /**
   * Carrusel de una tarjeta por pantalla. El desplazamiento sigue siendo el
   * nativo del navegador —con su inercia y su imán— y lo único que añade el
   * script son los saltos con flechas, los puntos y el arrastre con el ratón,
   * que es donde el navegador no ofrece ningún gesto.
   *
   * Es el mismo componente que usa Familia. La guarda de registro deja que
   * gane el primero que se cargue: los dos archivos declaran la misma clase.
   */
  (function () {
    function motionOff() {
      return (
        document.documentElement.dataset.motion === 'off' ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    }

    class UmbraCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-carousel-track]');
        if (!this.track) return;

        this.prevBtn = this.querySelector('[data-carousel-prev]');
        this.nextBtn = this.querySelector('[data-carousel-next]');
        this.stepBtn = this.querySelector('[data-carousel-step]');
        this.stepLabel = this.querySelector('[data-carousel-step-label]');
        this.dotsBox = this.querySelector('[data-carousel-dots]');

        this.index = 0;
        this.atEnd = false;
        this.frame = null;
        this.pointerId = null;
        this.startX = 0;
        this.startScroll = 0;

        this.onScroll = this.onScroll.bind(this);
        this.onDown = this.onDown.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onUp = this.onUp.bind(this);

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.index - 1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.index + 1));

        if (this.stepBtn) {
          this.stepBtn.addEventListener('click', () => {
            this.goTo(this.atEnd ? this.index - 1 : this.index + 1);
          });
        }

        // Al conectar, las fotos todavía no han cargado y las medidas del
        // recorrido salen en cero. Se vuelve a medir cuando la página termina
        // de cargar y cada vez que cambia el ancho de la ventana.
        window.addEventListener('load', this.onScroll);
        window.addEventListener('resize', this.onScroll);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('pointerdown', this.onDown);
        this.track.addEventListener('pointermove', this.onMove);
        this.track.addEventListener('pointerup', this.onUp);
        this.track.addEventListener('pointercancel', this.onUp);
        this.track.addEventListener('dragstart', (event) => event.preventDefault());

        this.refresh();
      }

      disconnectedCallback() {
        window.removeEventListener('load', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }

      cards() {
        return Array.from(this.track.children);
      }

      // La lista puede cambiar después de la primera carga —las reseñas llegan
      // de la API y sustituyen a las del editor—, así que los puntos y el
      // estado se reconstruyen a petición y no solo al conectar.
      refresh() {
        this.buildDots();
        this.update();
      }

      buildDots() {
        if (!this.dotsBox) return;

        const total = this.cards().length;
        this.dotsBox.innerHTML = '';
        if (total < 2) return;

        const template = this.dataset.dotLabel || '';

        for (let i = 0; i < total; i += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'familia__dot';
          dot.setAttribute('aria-label', template.replace('%%', String(i + 1)));
          dot.addEventListener('click', () => this.goTo(i));
          this.dotsBox.appendChild(dot);
        }
      }

      goTo(target) {
        const cards = this.cards();
        if (!cards.length) return;

        const index = Math.max(0, Math.min(cards.length - 1, target));

        this.track.scrollTo({
          left: cards[index].offsetLeft - this.track.offsetLeft,
          behavior: motionOff() ? 'auto' : 'smooth',
        });
      }

      onScroll() {
        // Se guarda el id del fotograma en vez de un booleano: si el callback no
        // llega a ejecutarse, un booleano quedaría en true para siempre y el
        // carrusel dejaría de responder al volver a la pestaña.
        if (this.frame) return;

        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        const cards = this.cards();
        if (!cards.length) return;

        const origin = this.track.offsetLeft + this.track.scrollLeft;
        let nearest = 0;
        let shortest = Infinity;

        cards.forEach((card, i) => {
          const distance = Math.abs(card.offsetLeft - origin);
          if (distance < shortest) {
            shortest = distance;
            nearest = i;
          }
        });

        this.index = nearest;

        // El final se comprueba también por scroll, por el resto de píxeles que
        // deja el imán. La comprobación exige que haya recorrido real: al
        // conectar, las imágenes aún no han cargado y el ancho medido es cero,
        // y sin esta condición el carrusel se daría por terminado antes de que
        // nadie lo tocara — que es lo que descubría el botón de opiniones desde
        // el primer momento.
        const scrollable = this.track.scrollWidth - this.track.clientWidth;
        const atEnd =
          nearest >= cards.length - 1 ||
          (scrollable > 0 && this.track.scrollLeft >= scrollable - 2);

        this.atEnd = atEnd;

        if (this.prevBtn) this.prevBtn.disabled = nearest === 0;
        if (this.nextBtn) this.nextBtn.disabled = atEnd;

        if (this.stepBtn) {
          // Con una sola tarjeta no hay recorrido y el control sobra.
          this.stepBtn.hidden = cards.length < 2;
          this.stepBtn.classList.toggle('is-back', atEnd);

          if (this.stepLabel) {
            this.stepLabel.textContent = atEnd
              ? this.stepBtn.dataset.labelPrev || ''
              : this.stepBtn.dataset.labelNext || '';
          }
        }

        if (this.dotsBox) {
          Array.from(this.dotsBox.children).forEach((dot, i) => {
            dot.classList.toggle('is-active', i === nearest);
            dot.setAttribute('aria-current', i === nearest ? 'true' : 'false');
          });
        }

        this.dispatchEvent(
          new CustomEvent('umbra:carousel:change', {
            bubbles: true,
            detail: { index: nearest, count: cards.length, atEnd: atEnd },
          })
        );
      }

      onDown(event) {
        // El dedo y el lápiz se quedan con el scroll nativo, que se siente mejor
        // que cualquier arrastre calculado a mano.
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        this.pointerId = event.pointerId;
        this.startX = event.clientX;
        this.startScroll = this.track.scrollLeft;
        this.track.setPointerCapture(event.pointerId);
        this.track.classList.add('is-dragging');
      }

      onMove(event) {
        if (this.pointerId !== event.pointerId) return;

        this.track.scrollLeft = this.startScroll - (event.clientX - this.startX);
        event.preventDefault();
      }

      onUp(event) {
        if (this.pointerId !== event.pointerId) return;

        if (this.track.hasPointerCapture(event.pointerId)) {
          this.track.releasePointerCapture(event.pointerId);
        }

        this.pointerId = null;
        this.track.classList.remove('is-dragging');
      }
    }

    if (!customElements.get('umbra-carousel')) {
      customElements.define('umbra-carousel', UmbraCarousel);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["star-rating"] && !Shopify.designMode) return;
  try {
    /** Las estrellas caen cuando el bloque entra en pantalla, no al cargar. */
  (function () {
    class UmbraRating extends HTMLElement {
      connectedCallback() {
        const motionOff =
          document.documentElement.dataset.motion === 'off' ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (motionOff) return;

        this.classList.add('is-armed');

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.classList.add('is-falling');
              this.observer.disconnect();
            });
          },
          { threshold: 0.4 }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }

    if (!customElements.get('umbra-rating')) {
      customElements.define('umbra-rating', UmbraRating);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["to-top"] && !Shopify.designMode) return;
  try {
    class UmbraToTop extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-to-top-button]');
      this.sentinel = this.querySelector('[data-to-top-sentinel]');
      if (!this.button || !this.sentinel) return;

      this.button.addEventListener('click', () => {
        const motionOff =
          document.documentElement.dataset.motion === 'off' ||
          window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        window.scrollTo({ top: 0, behavior: motionOff ? 'auto' : 'smooth' });
      });

      // Primera lectura sin esperar a ningún evento: si la página se abre ya
      // desplazada —una recarga a media lectura, un enlace con ancla— el botón
      // tiene que estar desde el primer fotograma en vez de aparecer al
      // siguiente gesto.
      this.update(this.sentinel.getBoundingClientRect().top);

      // Sin observador el botón se queda con esa primera lectura, que es el
      // estado correcto: es una comodidad, no una salida de emergencia.
      if (!('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // Solo cuenta haberlo dejado atrás hacia arriba. Al cargar la
            // página el centinela está por debajo de la pantalla y tampoco se
            // cruza: sin esta comprobación el botón aparecería desde el primer
            // momento, que es justo lo que no debe pasar.
            if (entry.isIntersecting) {
              this.update(1);
              return;
            }

            this.update(entry.boundingClientRect.top);
          });
        },
        { threshold: 0 }
      );

      this.observer.observe(this.sentinel);
    }

    /** Visible solo cuando el centinela quedó por encima de la pantalla. */
    update(top) {
      const passed = top < 0;

      this.classList.toggle('is-visible', passed);
      this.button.hidden = !passed;
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  if (!customElements.get('umbra-to-top')) {
    customElements.define('umbra-to-top', UmbraToTop);
  }
  } catch(e) { console.error(e); }
})();

})();
